import oeWheelsDefaults from '../366f27-a8/config.js';

export default {
  includes: ['shopify-generic', '366f27-a8'],
  ...oeWheelsDefaults,
};
